import React from 'react';

function SurveyFeature({ isMobile, t }) {
  return (
    <section
      style={{
        marginTop: 200,
        marginBottom: 40,
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <div
        style={{
          maxWidth: '1200px',
          width: '100%',
          padding: isMobile ? '0 20px' : '0 40px',
          color: '#f9fafb'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 16,
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              justifyContent: 'start',
              borderRadius: 18,
              padding: 18,
              backdropFilter: 'blur(10px)',
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: isMobile ? 24 : 30,
              alignItems: isMobile ? 'stretch' : 'center'
            }}
          >
            
            <div style={{ flex: 1, alignItems: 'flex-center', justifyContent: 'flex-center', maxWidth: 400 }}>
              <h3
                style={{
                  margin: '0 0 8px 0',
                  fontSize: '2rem',
                  fontFamily: 'Poppins-Medium'
                }}
              >
                {t.SurveyTitle}
              </h3>
              <p
                style={{
                  margin: 0,
                  fontSize: '1.1rem',
                  opacity: 0.9,
                  lineHeight: 1.6
                }}
              >
                {t.SurveyText}
              </p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12, minWidth: 350 }}>
              {/* Titre du sondage */}
              <div style={{
                marginBottom: 16,
                paddingBottom: 12,
                borderBottom: '1px solid rgba(148, 163, 184, 0.2)'
              }}>
                <h4 style={{
                  margin: 0,
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  color: '#ffffff',
                  fontFamily: 'Poppins-Medium',
                  textAlign: 'left',
                  marginLeft: 10,
                }}>
                  {t.whichRestau}
                </h4>
              </div>

              {/* Option 1 - Pizza loca */}
              <div style={{
                backgroundColor: 'rgba(30, 41, 59, 0.9)',
                borderRadius: 15,
                padding: '16px',
                border: '1px solid rgba(148, 163, 184, 0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                position: 'relative'
              }}>
                <div style={{ flex: 1 }}>
                  <h5 style={{
                    margin: '0 0 2px 0',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    color: '#ffffff',
                    fontFamily: 'Poppins-Medium',
                    textAlign: 'left'
                  }}>
                    {t.restau3}
                  </h5>
                  <p style={{
                    margin: '0 0 2px 0',
                    fontSize: '0.75rem',
                    color: '#94a3b8',
                    fontFamily: 'Poppins-Medium',
                    textAlign: 'left'
                  }}>
                    {t.votes1}
                  </p>
                  <div style={{ textAlign: 'left', marginBottom: 8 }}>
                    <div style={{
                      display: 'inline-block',
                      backgroundColor: 'rgba(51, 65, 85, 0.8)',
                      borderRadius: 12,
                      padding: '4px 10px',
                      fontSize: '0.7rem',
                      color: '#e2e8f0',
                      fontFamily: 'Poppins-Medium',
                    }}>
                      Sophia
                    </div>
                  </div>
                  <div style={{
                    width: '100%',
                    height: 4,
                    backgroundColor: 'rgba(139, 92, 246, 0.3)',
                    borderRadius: 2,
                    marginTop: 8
                  }}>
                    <div style={{
                      width: '50%',
                      height: '100%',
                      backgroundColor: '#8b5cf6',
                      borderRadius: 2
                    }} />
                  </div>
                </div>
                <div style={{
                  width: 20,
                  height: 20,
                  borderRadius: '50%',
                  border: '2px solid rgba(148, 163, 184, 0.5)',
                  backgroundColor: 'transparent',
                  flexShrink: 0
                }} />
              </div>

              {/* Option 2 - La table du coin */}
              <div style={{
                backgroundColor: 'rgba(30, 41, 59, 0.9)',
                borderRadius: 15,
                padding: '16px',
                border: '1px solid rgba(148, 163, 184, 0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                position: 'relative'
              }}>
                <div style={{ flex: 1 }}>
                  <h5 style={{
                    margin: '0 0 2px 0',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    color: '#ffffff',
                    fontFamily: 'Poppins-Medium',
                    textAlign: 'left'
                  }}>
                    {t.restau2}
                  </h5>
                  <p style={{
                    margin: '0 0 8px 0',
                    fontSize: '0.75rem',
                    color: '#94a3b8',
                    fontFamily: 'Poppins-Medium',
                    textAlign: 'left'
                  }}>
                    {t.votes2}
                  </p>
                </div>
                <div style={{
                  width: 20,
                  height: 20,
                  borderRadius: '50%',
                  border: '2px solid rgba(148, 163, 184, 0.5)',
                  backgroundColor: 'transparent',
                  flexShrink: 0
                }} />
              </div>

              {/* Option 3 - Le petit bistrot (sélectionné) */}
              <div style={{
                backgroundColor: 'rgba(139, 92, 246, 0.3)',
                borderRadius: 15,
                padding: '16px',
                border: '1px solid rgba(139, 92, 246, 0.5)',
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                position: 'relative'
              }}>
                <div style={{ flex: 1 }}>
                  <h5 style={{
                    margin: '0 0 2px 0',
                    fontSize: '0.9rem',
                    fontWeight: 'bold',
                    color: '#ffffff',
                    fontFamily: 'Poppins-Medium',
                    textAlign: 'left'
                  }}>
                    {t.restau1}
                  </h5>
                  <p style={{
                    margin: '0 0 2px 0',
                    fontSize: '0.75rem',
                    color: '#cbd5e1',
                    fontFamily: 'Poppins-Medium',
                    textAlign: 'left'
                  }}>
                    {t.votes1}
                  </p>
                  <div style={{ textAlign: 'left', marginBottom: 8 }}>
                    <div style={{
                      display: 'inline-block',
                      backgroundColor: 'rgba(51, 65, 85, 0.8)',
                      borderRadius: 12,
                      padding: '4px 10px',
                      fontSize: '0.7rem',
                      color: '#e2e8f0',
                      fontFamily: 'Poppins-Medium',
                    }}>
                      Etan
                    </div>
                  </div>
                  <div style={{
                    width: '100%',
                    height: 4,
                    backgroundColor: 'rgba(139, 92, 246, 0.3)',
                    borderRadius: 2,
                    marginTop: 8
                  }}>
                    <div style={{
                      width: '50%',
                      height: '100%',
                      backgroundColor: '#8b5cf6',
                      borderRadius: 2
                    }} />
                  </div>
                </div>
                <div style={{
                  width: 20,
                  height: 20,
                  borderRadius: '50%',
                  border: '2px solid #8b5cf6',
                  backgroundColor: '#8b5cf6',
                  flexShrink: 0,
                  position: 'relative'
                }}>
                  <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    backgroundColor: '#ffffff'
                  }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SurveyFeature;
